<template>
    <div class="custom-select"
         :class="{open}"
         tabindex="0"
         @focus="activate()"
         @blur="deactivate()"
         @keydown.prevent.stop.up="selectPrevOption()"
         @keydown.prevent.stop.down="selectNextOption()"
         @keydown.prevent.stop.enter="deactivate()">

        <select @change="onChange($event.target.value)" v-bind="$attrs" tabindex="-1">
            <option v-for="option in options"
                    :selected="getOptionValue(option) === value"
                    :value="getOptionValue(option)"
                    v-html="getOptionLabel(option)">
            </option>
        </select>
        <div class="custom-select-trigger">
            <div>
                <transition>
                    <span :key="getValueLabel(value)" v-html="getValueLabel(value)"></span>
                </transition>
            </div>
        </div>
        <transition>
            <ul class="custom-select-options" v-show="open">
                <li class="custom-select-option"
                    :class="{selected: isSelected(option)}"
                    v-for="option in options"
                    @click="onChange(getOptionValue(option))"
                    v-html="getOptionLabel(option)">
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
    export default {
        inheritAttrs: false,
        model: {
            prop: 'value',
            event: 'change',
        },
        props: {
            value: {},
            options: {
                type: Array,
                default() {
                    return {};
                },
            },
            breakpoint: {
                type: Number,
                default: 768,
            },
            labelField: {
                type: String,
                default: 'label',
            },
            valueField: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                open: false,
                screenWidth: window.innerWidth,
            };
        },
        computed: {
            isMobile() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            activate() {
                if (this.open) {
                    return;
                }
                this.open = true;
                this.$el.focus();
            },
            deactivate() {
                if (!this.open) {
                    return;
                }
                this.open = false;
                this.$el.blur();
            },
            selectPrevOption() {
                this.selectNextOption(false);
            },
            selectNextOption(next = true) {
                let currentIndex = this.options.findIndex(option => this.isSelected(option));
                let newIndex = next ?
                    (currentIndex + 1) % this.options.length :
                    (currentIndex - 1 + this.options.length) % this.options.length;

                this.$emit('change', this.getOptionValue(this.options[newIndex]));
            },
            isSelected(option) {
                return this.getOptionValue(option) === this.value;
            },
            onChange(value) {
                this.deactivate();
                this.$emit('change', value);
            },
            onResize() {
                this.screenWidth = window.innerWidth;
            },
            getOptionLabel(option) {
                return typeof option === 'object' ? option[this.labelField] : option;
            },
            getOptionValue(option) {
                return typeof option === 'object' && this.valueField ? option[this.valueField] : option;
            },
            getValueLabel(value) {
                if (typeof value === 'object' && this.labelField in value) {
                    return value[this.labelField];
                }
                let option = this.options.find(option => option[this.valueField] === value);

                return option[this.labelField];
            },
        },
        created() {
            window.addEventListener('resize', this.onResize.bind(this));
        },
        destroyed() {
            window.removeEventListener('resize', this.onResize.bind(this));
        },
    };
</script>